import { render } from "./ui-stickynote.vue?vue&type=template&id=6941ccc0"
import script from "./ui-stickynote.vue?vue&type=script&lang=js"
export * from "./ui-stickynote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__